import styled from 'styled-components';
import query from '../../../const/mediaQueries';
const minimumScreenSize = '(min-width: 0px)';
const generateRowGapMediaQuery = (gap, mediaQueryStr) => {
    const marginTop = typeof (gap === null || gap === void 0 ? void 0 : gap.rowGap) === 'number' ? `${gap === null || gap === void 0 ? void 0 : gap.rowGap}px` : gap.rowGap;
    const marginLeft = typeof (gap === null || gap === void 0 ? void 0 : gap.columnGap) === 'number' ? `${gap === null || gap === void 0 ? void 0 : gap.columnGap}px` : gap.columnGap;
    return `@media ${mediaQueryStr} {
    margin-top: -${marginTop !== null && marginTop !== void 0 ? marginTop : '0px'};
    margin-left: -${marginLeft !== null && marginLeft !== void 0 ? marginLeft : '0px'};
  }`;
};
export const Row = styled.div `
  align-content: ${({ alignContent }) => alignContent};
  align-items: ${({ alignItems }) => alignItems};
  display: flex;
  flex-direction: ${({ direction }) => direction};
  flex-wrap: ${({ wrap }) => wrap};
  justify-content: ${({ justifyContent }) => justifyContent};
  ${({ mobileGap }) => mobileGap && generateRowGapMediaQuery(mobileGap, minimumScreenSize)}
  ${({ tabletGap }) => tabletGap && generateRowGapMediaQuery(tabletGap, query.greaterThanMedium)}
  ${({ desktopGap }) => desktopGap && generateRowGapMediaQuery(desktopGap, query.greaterThanLarge)}
  @media ${query.lessThanSmall} {
    flex-wrap: wrap;
  }
`;
const generateColumnMediaQuery = (breakpoint, mediaQueryStr) => {
    if (breakpoint === 'auto') {
        return `
      box-sizing: border-box;
      flex: 0 0 auto;
      width: auto;
    `;
    }
    const width = `${(breakpoint / 12) * 100}%`;
    return `@media ${mediaQueryStr} {
      box-sizing: border-box;
      flex-basis: ${width}; 
      flex-grow: 0; 
      max-width: ${width};
    }`;
};
const generateColumnGapMediaQuery = (gap, mediaQueryStr) => {
    const paddingTop = typeof (gap === null || gap === void 0 ? void 0 : gap.rowGap) === 'number' ? `${gap === null || gap === void 0 ? void 0 : gap.rowGap}px` : gap.rowGap;
    const paddingLeft = typeof (gap === null || gap === void 0 ? void 0 : gap.columnGap) === 'number' ? `${gap === null || gap === void 0 ? void 0 : gap.columnGap}px` : gap.columnGap;
    return `@media ${mediaQueryStr} {
    padding-top: ${paddingTop !== null && paddingTop !== void 0 ? paddingTop : '0px'};
    padding-left: ${paddingLeft !== null && paddingLeft !== void 0 ? paddingLeft : '0px'};
   }`;
};
export const Column = styled.div `
  ${({ xs, sm, md, lg, xl }) => !xs && !sm && !md && !lg && !xl && 'flex: auto;'}
  ${({ xs }) => xs && generateColumnMediaQuery(xs, minimumScreenSize)}
  ${({ sm }) => sm && generateColumnMediaQuery(sm, query.greaterThanSmall)}
  ${({ md }) => md && generateColumnMediaQuery(md, query.greaterThanMedium)}
  ${({ lg }) => lg && generateColumnMediaQuery(lg, query.greaterThanLarge)}
  ${({ xl }) => xl && generateColumnMediaQuery(xl, query.greaterThanHuge)}

  ${({ mobileGap }) => mobileGap && generateColumnGapMediaQuery(mobileGap, minimumScreenSize)}
  ${({ tabletGap }) => tabletGap &&
    generateColumnGapMediaQuery(tabletGap, query.greaterThanMedium)}
  ${({ desktopGap }) => desktopGap &&
    generateColumnGapMediaQuery(desktopGap, query.greaterThanLarge)}
`;
//# sourceMappingURL=subcomponents.js.map